// The tiers a Copilot review runs at.
export const REVIEW_EFFORT_TIERS = ['low', 'medium', 'high'] as const
export type ReviewEffortTier = (typeof REVIEW_EFFORT_TIERS)[number]

// The efforts a Copilot review can be requested or saved with. With `auto`, Copilot picks a tier for each
// review, so `auto` is never the tier a review ran at.
export const REVIEW_EFFORT_VALUES = [...REVIEW_EFFORT_TIERS, 'auto'] as const
export type ReviewEffortValue = (typeof REVIEW_EFFORT_VALUES)[number]

// Settings get their copy from the server with each option; this is for surfaces without options.
const REVIEW_EFFORT_LABELS: Record<ReviewEffortValue, string> = {
  low: 'Lite',
  medium: 'Balanced',
  high: 'Max',
  auto: 'Auto',
}

export function isReviewEffortValue(value: unknown): value is ReviewEffortValue {
  return REVIEW_EFFORT_VALUES.some(effort => effort === value)
}

export function isReviewEffortTier(value: unknown): value is ReviewEffortTier {
  return REVIEW_EFFORT_TIERS.some(tier => tier === value)
}

export function reviewEffortLabel(value: ReviewEffortValue): string {
  return REVIEW_EFFORT_LABELS[value]
}

// Max and Auto are in preview, so effort pickers label them Preview even when they're available.
export function isPreviewReviewEffort(value: unknown): boolean {
  return value === 'high' || value === 'auto'
}
